import { ICON_HEIGHT_16 } from '../../../../Icon'
import { ScrollMode, SpreadMode } from '../../../PdfViewer.constants'

import ViewControlsIcon from '../../../../../icons/settings.svg'

export const PDF_VIEWER_TOOLBAR_VIEW_CONTROLS_ICON_PROPS = {
  Icon: ViewControlsIcon,
  svgSize: ICON_HEIGHT_16,
}

export const QA_NAME_PDF_VIEWER_TOOLBAR_VIEW_CONTROLS_BTN =
  'pdfViewerToolbarViewControls'

export const PDF_VIEWER_VIEW_CONTROLS_SECTION_ID = {
  pageLayout: 'pageLayout',
  pageOrientation: 'pageOrientation',
  pageTransition: 'pageTransition',
}

export const PDF_VIEWER_SCROLL_MODE_OPTIONS = [
  {
    qaName: 'pdfViewerContinuousPage',
    titleKey: 'PdfViewer.ContinuousPageKey',
    value: ScrollMode.VERTICAL,
  },
  {
    qaName: 'pdfViewerPageByPage',
    titleKey: 'PdfViewer.PageByPageKey',
    value: ScrollMode.PAGE,
  },
]

export const PDF_VIEWER_SPREAD_MODE_OPTIONS = [
  {
    qaName: 'pdfViewerSinglePage',
    titleKey: 'PdfViewer.SinglePageKey',
    value: SpreadMode.NONE,
  },
  {
    qaName: 'pdfViewerDoublePage',
    titleKey: 'PdfViewer.DoublePageKey',
    value: SpreadMode.ODD,
  },
  {
    qaName: 'pdfViewerCoverFacingPage',
    titleKey: 'PdfViewer.CoverFacingPageKey',
    value: SpreadMode.EVEN,
  },
]
